import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Select, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import { TripTaskType, type ETripTaskType } from 'types/trips';
import { getAllowedTaskTypesForEdit } from 'components/trips/trip-edit-task-modal/utils';
import type { IEditTaskTypeProps } from './types';

export const EditTaskType = (props: IEditTaskTypeProps) => {
  const { tripStatus } = props;
  const { t } = useTranslation('trip');

  const { taskType, originalTaskType, setTaskType } = useTripTaskStore();

  const options = useMemo(() => {
    if (!originalTaskType) return [];

    const allowedTypes = getAllowedTaskTypesForEdit(originalTaskType, tripStatus);

    return allowedTypes.map((type) => ({
      value: type,
      label: TripTaskType[type],
    }));
  }, [originalTaskType, tripStatus]);

  const helperText =
    tripStatus === 'planning' ? t('edit_task_type_helper_planning') : t('edit_task_type_helper_started');

  const handleChange = (value: ETripTaskType) => {
    setTaskType(value);
  };

  return (
    <Flex gap='large' vertical>
      <Typography.Text type='secondary'>{helperText}</Typography.Text>
      <Select
        size='large'
        placeholder={t('select_task_type')}
        value={taskType}
        options={options}
        onChange={handleChange}
      />
    </Flex>
  );
};
